import { render, staticRenderFns } from "./distribution-channel.vue?vue&type=template&id=6866208e&scoped=true"
import script from "./distribution-channel.vue?vue&type=script&lang=js"
export * from "./distribution-channel.vue?vue&type=script&lang=js"
import style0 from "./distribution-channel.vue?vue&type=style&index=0&id=6866208e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6866208e",
  null
  
)

export default component.exports